module.exports = __webpack_public_path__ + "static/media/product.05c3dc92.png";